import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const BrandStoryPage = lazy(() => import('../pages/brand-story/page'));
const WhoWeServePage = lazy(() => import('../pages/who-we-serve/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const RoastedCoffeePage = lazy(() => import('../pages/products/roasted-coffee/page'));
const PodsPage = lazy(() => import('../pages/products/pods/page'));
const CapsulesPage = lazy(() => import('../pages/products/capsules/page'));
const MilkshakesPage = lazy(() => import('../pages/products/milkshakes/page'));
const HorecaPage = lazy(() => import('../pages/products/horeca/page'));
const TeaPage = lazy(() => import('../pages/products/tea/page'));
const MachinesPage = lazy(() => import('../pages/products/machines/page'));
// Horeca sub-pages
const ColdGlazePage = lazy(() => import('../pages/products/horeca/cold-glaze/page'));
const ToppingSaucePage = lazy(() => import('../pages/products/horeca/topping-sauce/page'));
const CoffeeBarSaucePage = lazy(() => import('../pages/products/horeca/coffee-bar-sauce/page'));
const FillingSaucePage = lazy(() => import('../pages/products/horeca/filling-sauce/page'));
const FillingFruitPage = lazy(() => import('../pages/products/horeca/filling-fruit/page'));
const PralinePage = lazy(() => import('../pages/products/horeca/praline/page'));
const RefresherPage = lazy(() => import('../pages/products/horeca/refresher/page'));
// Chocolate
const ChocolatePage = lazy(() => import('../pages/products/chocolate/page'));
// Elite pages
const EliteCoffeePage = lazy(() => import('../pages/elite/coffee/page'));
const EliteColombianPage = lazy(() => import('../pages/elite/coffee/colombian/page'));
const EliteEthiopianPage = lazy(() => import('../pages/elite/coffee/ethiopian/page'));
const EliteLuxuryPage = lazy(() => import('../pages/elite/coffee/luxury/page'));
const EliteMilkshakePage = lazy(() => import('../pages/elite/milkshake/page'));
const EliteTeaPage = lazy(() => import('../pages/elite/tea/page'));
const ElitePodsPage = lazy(() => import('../pages/elite/pods/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/brand-story',
    element: <BrandStoryPage />,
  },
  {
    path: '/who-we-serve',
    element: <WhoWeServePage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/roasted-coffee',
    element: <RoastedCoffeePage />,
  },
  {
    path: '/products/pods',
    element: <PodsPage />,
  },
  {
    path: '/products/capsules',
    element: <CapsulesPage />,
  },
  {
    path: '/products/milkshakes',
    element: <MilkshakesPage />,
  },
  {
    path: '/products/horeca',
    element: <HorecaPage />,
  },
  {
    path: '/products/horeca/cold-glaze',
    element: <ColdGlazePage />,
  },
  {
    path: '/products/horeca/topping-sauce',
    element: <ToppingSaucePage />,
  },
  {
    path: '/products/horeca/coffee-bar-sauce',
    element: <CoffeeBarSaucePage />,
  },
  {
    path: '/products/horeca/filling-sauce',
    element: <FillingSaucePage />,
  },
  {
    path: '/products/horeca/filling-fruit',
    element: <FillingFruitPage />,
  },
  {
    path: '/products/horeca/praline',
    element: <PralinePage />,
  },
  {
    path: '/products/horeca/refresher',
    element: <RefresherPage />,
  },
  {
    path: '/products/chocolate',
    element: <ChocolatePage />,
  },
  // Elite routes
  {
    path: '/elite/coffee',
    element: <EliteCoffeePage />,
  },
  {
    path: '/elite/coffee/colombian',
    element: <EliteColombianPage />,
  },
  {
    path: '/elite/coffee/ethiopian',
    element: <EliteEthiopianPage />,
  },
  {
    path: '/elite/coffee/luxury',
    element: <EliteLuxuryPage />,
  },
  {
    path: '/elite/milkshake',
    element: <EliteMilkshakePage />,
  },
  {
    path: '/elite/tea',
    element: <EliteTeaPage />,
  },
  {
    path: '/elite/pods',
    element: <ElitePodsPage />,
  },
  {
    path: '/elite/chocolate',
    element: <ChocolatePage />,
  },
  {
    path: '/products/tea',
    element: <TeaPage />,
  },
  {
    path: '/products/machines',
    element: <MachinesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
